import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/api";
import { Shell } from "@/components/Shell";
import { Check, Sparkles, FileText, Recycle, FolderOpen } from "lucide-react";

const PERKS = [
  "Unlimited quotes, invoices & waste notes",
  "Branded PDFs with your logo & details",
  "Per-client Job Files & history",
  "Kai AI assistant — draft docs by chat",
  "One-tap share to WhatsApp, email & SMS",
];

export default function Paywall() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const subscribe = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/billing/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not start checkout — please try again"); setLoading(false); }
  };

  return (
    <Shell back title="Docket Pro" showNav={false}>
      <div className="animate-fade-up">
        <div className="bg-onSurface text-onBrand rounded-[24px] p-6 relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-brandPrimary/30 blur-2xl" />
          <div className="relative">
            <div className="inline-flex items-center gap-1.5 bg-brandPrimary/20 text-brandPrimary px-3 py-1 rounded-full text-xs font-bold mb-4"><Sparkles size={13} /> Everything unlocked</div>
            <div className="flex items-end gap-1">
              <span className="font-heading text-5xl font-extrabold">£12</span>
              <span className="text-white/60 mb-1.5">/month</span>
            </div>
            <p className="text-sm text-white/70 mt-1">7-day free trial included · cancel anytime.</p>
          </div>
        </div>

        <div className="mt-5 space-y-3">
          {PERKS.map((p) => (
            <div key={p} className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full bg-success/15 flex items-center justify-center shrink-0"><Check size={15} className="text-success" /></div>
              <span className="text-sm font-medium text-onSurface">{p}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-3 gap-3">
          {[[FileText, "Quotes"], [Recycle, "Waste notes"], [FolderOpen, "Job files"]].map(([Icon, l]) => (
            <div key={l} className="bg-surface border border-border rounded-[12px] p-3 flex flex-col items-center gap-2"><Icon size={20} className="text-brandPrimary" /><span className="text-xs font-semibold text-muted-foreground">{l}</span></div>
          ))}
        </div>
      </div>

      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-surface/95 backdrop-blur-md border-t border-border p-4" style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 16px)" }}>
        <button data-testid="paywall-subscribe-btn" disabled={loading} onClick={subscribe} className="w-full bg-brandPrimary text-onBrand rounded-full h-14 font-heading font-bold text-base flex items-center justify-center gap-2 hover:bg-brandSecondary transition-colors active:scale-[0.98] disabled:opacity-50">
          {loading ? "Starting checkout…" : "Subscribe now"}
        </button>
        <p className="text-center text-xs text-muted-foreground mt-2">Secure payment by Stripe · charged immediately</p>
      </div>
    </Shell>
  );
}
